module.exports = __webpack_public_path__ + "static/018.thumb-42fe81c5baded592e313cdec916b8a67.jpg";